admin sample